import React from 'react'
import sideBarStyle from './styles'
import config from './config'
import { Tooltip } from '@mui/material'

const SideBar = () => {
  const classes = sideBarStyle()
  const configuration = config()
  return (
    <nav className={classes.nav}>
      <ul className={classes.navList}>
        {configuration.map((item) => (
          <Tooltip
            key={item.section}
            title={item.tooltip}
            placement="left"
            arrow
          >
            <li className={classes.navListElement}>
              <a href={item.section} aria-label={`${item.tooltip}`}>
                {item.icon}
              </a>
            </li>
          </Tooltip>
        ))}
      </ul>
    </nav>
  )
}

export default SideBar
